import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const TomsGuide = ({featuredProjectsList}) => {
  const project = getProject('toms-guide');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          component={{
            image: '//images.yourmajesty.co/20170510163621/toms-header.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            Tom’s guide, a tech publication and gadget recommendation website,
            competes with publication giants like CNET and Engadget. To ensure a
            more engaging and valuable experience for Tom’s guide readers, Your
            Majesty led a lean UX process driven by constant experimentation and
            learning.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503202710/02_best-picks_B.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503202711/04_Buying-Guides-Topic_C.jpg',
            caption:
              'New content types, like Buying Guides, help writers recommend the best products for fitness, travel, and other everyday contexts.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="ideate-prototype-learn">Ideate, prototype, learn</h2>
          <p>
            Testing design assumptions regularly in the hands of real users
            uncovered and validated user behaviors before the site even began
            development. Influenced by the learnings, the redesigned tech
            publication serves goal-orientated readers in new ways, with
            functional tools, a smarter search experience, new comparison
            features and lifestyle-based editorial recommendations.
          </p>
        </AnimateIn>

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170510165642/toms-testing.jpg'
          }}
        />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '216873995'
          }}
        />

        <Image
          className="g-row"
          component={{
            image:
              '//images.yourmajesty.co/20170503202713/05_product-matchmaker.jpg',
            caption:
              'New features make finding the right products as easy as answering some basic questions.'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503202714/06_news.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="milestones">Milestones</h2>
          <ul>
            <li>
              Ten design sprints, over fifty user testing sessions, countless
              valuable insights.
            </li>
            <li>2.7 million monthly increase in visitors from the US.</li>
          </ul>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Collaborative Working Sessions',
                  'Content Strategy',
                  'Experience Mapping',
                  'Interviews & User Testing',
                  'Prototyping & Validation',
                  'Research',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: ['Art Direction', 'UI/UX Design', 'Visual Design']
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'http://www.tomsguide.com/',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default TomsGuide;
